import React from 'react';

const NotFound = () => {
  return <h5>You are looking for a page that doesn't exist.</h5>;
};

export default NotFound;
